import { useField } from "formik";
import { EfsMelcoModelsColorListItem } from "melco-shared-logic";
import { useCallback } from "react";

export const useSchemaListIndex = () => {
  const [{ value: schemaList }] = useField<
    EfsMelcoModelsColorListItem[] | undefined
  >("schema_list");

  return useCallback(
    (id: string | undefined) => schemaList?.findIndex((x) => x.id === id),
    [schemaList]
  );
};
